<template>

    <v-card>
        <v-card-title>Auto Refresh Settings</v-card-title>

        <v-divider />

        <v-card-text>

            <v-form ref="refreshSettingsForm" :lazy-validation="true" v-model="formValid">
                <v-row dense>
                    <v-col cols="12">
                        <v-switch label="Auto Refresh Enabled" v-model="refreshSettingsClone.enabled" color="#c42111"></v-switch>
                    </v-col>
                    <v-col cols="12">
                        <v-select label="Upon refresh, report period parameters should:" v-model="refreshSettingsClone.refreshType" :items="refreshTypes" color="#c42111" :disabled="!refreshSettingsClone.enabled" />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field label="Refresh Interval (min)" v-model="refreshSettingsClone.refreshIntervalMin" type="number" min="0.1" color="#c42111" :disabled="!refreshSettingsClone.enabled" :rules="[validation.posNum(refreshSettingsClone.refreshIntervalMin)]" />
                    </v-col>
                </v-row>
            </v-form>

        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn @click="$emit('cancel')" text>Cancel</v-btn>
            <v-btn @click="okClick" text>Ok</v-btn>
        </v-card-actions>
    </v-card>

</template>

<script>
export default {
    name: 'RefreshSettings',
    props: ['refreshSettings'],
    components: {
    },
    data: () => ({
        formValid: true,
        refreshTypes: [
            {text: 'Remain as configured', value: 'nochange'},
            {text: 'Advance end date only', value: 'enddate'},
            {text: 'Maintain sliding day window', value: 'window'},
        ],
        refreshSettingsClone: null,
        validation: {
            posNum: (value) => (!isNaN(Number(value)) && value > 0) || `Value must be positive`
        }
    }),

    computed: {
    },

    methods: {
        okClick: function() {
            if(this.$refs.refreshSettingsForm.validate()) {
                this.$emit('refreshSettingsChange', this.refreshSettingsClone);
            }
        }

    },

    mounted() {
    },

    created() {
        this.refreshSettingsClone = JSON.parse(JSON.stringify(this.$props.refreshSettings));
    },
};
</script>

<style scoped>



</style>

